// import engineIcon from "../assets/images/icon-1-trans.png";
// import durabilityIcon from "../assets/images/icon-2-trans.png";
// import powerIcon from "../assets/images/icon-3-trans.png";

// const listCardsData = [
//   {
//     id: "card-1",
//     icon: engineIcon,
//     titleKey: "common.staticTexts.reliabilityCardTitleOne",
//     description:
//       "Durable Components tested for Saudi weather and road conditions."
//   },
//   {
//     id: "card-2",
//     icon: durabilityIcon,
//     title: "Powerful Engine",
//     description:
//       "Fuel efficiency without compromise."
//   },
//   {
//     id: "card-3",
//     icon: powerIcon,
//     title: "Easy Maintenance",
//     description:
//       "With parts and service availability across the Kingdom."
//   }
// ];

// export default listCardsData;



import engineIcon from "../assets/images/icon-1-trans.png";
import durabilityIcon from "../assets/images/icon-2-trans.png";
import powerIcon from "../assets/images/icon-3-trans.png";

const listCardsData = [
  {
    id: "card-1",
    icon: engineIcon,
    titleKey: "common.staticTexts.reliabilityCardTitleOne",
    descriptionKey: "common.staticTexts.reliabilityCardDescOne",
  },
  {
    id: "card-2",
    icon: durabilityIcon,
    titleKey: "common.staticTexts.reliabilityCardTitleTwo",
    descriptionKey: "common.staticTexts.reliabilityCardDescTwo",
  },
  {
    id: "card-3",
    icon: powerIcon,
    titleKey: "common.staticTexts.reliabilityCardTitleThree",
    descriptionKey: "common.staticTexts.reliabilityCardDescThree",
  }
];

export default listCardsData;
